if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (this.form.querySelector('[name=id]')) {
          this.form.querySelector('[name=id]').disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        if (document.querySelector('cart-drawer') && this.submitButton) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        // Verificar se está no popup de lentes
        const isLensPopup = this.closest('.ec-lens-popup--container');
        const lensVariantIdInput = this.form.querySelector('[name="lens_variant_id"][data-ec-lens-popup="true"]');
        const hasLensSelected = lensVariantIdInput && lensVariantIdInput.value;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading-overlay__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (this.submitButton.id != "ProductSubmitButton-product-quickview") {
            this.cart.setActiveElement(document.activeElement);
          }
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then(async (response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            // Se está no popup e tem lente selecionada, adicionar a lente como nested cart line
            if (isLensPopup && hasLensSelected) {
              const lensVariantId = Number(lensVariantIdInput.value);
              if (lensVariantId && !isNaN(lensVariantId)) {
                try {
                  console.log('🔍 Adicionando lente ao carrinho como nested cart line:', lensVariantId);
                  
                  // Obter o key da armação (pai) do response
                  // O key pode estar em response.items[0].key ou response.key
                  let parentLineKey = null;
                  
                  // Log do response para debug
                  console.log('📋 Response da armação:', response);
                  
                  if (response.items && response.items.length > 0) {
                    // Se o response tem items array, pegar o key do primeiro item (a armação recém-adicionada)
                    parentLineKey = response.items[0].key;
                    console.log('📦 Key encontrado em response.items[0].key:', parentLineKey);
                  } else if (response.key) {
                    // Se não tem items array, usar o key direto do response
                    parentLineKey = response.key;
                    console.log('📦 Key encontrado em response.key:', parentLineKey);
                  } else {
                    // Tentar buscar do cart atual se não estiver no response
                    console.warn('⚠️ Key da armação não encontrada no response. Estrutura do response:', Object.keys(response));
                    // Se não conseguir, ainda assim tentar adicionar sem parent (fallback)
                  }
                  
                  if (parentLineKey) {
                    console.log('✅ Key da armação (pai) encontrado:', parentLineKey);
                  } else {
                    console.warn('⚠️ Não foi possível obter o key da armação. A lente será adicionada sem relação pai-filho.');
                  }
                  
                  // Preparar o request da lente com nested cart line usando JSON
                  const lensConfig = fetchConfig('javascript');
                  lensConfig.headers['X-Requested-With'] = 'XMLHttpRequest';
                  
                  // Construir o objeto de items para nested cart lines
                  const lensItems = [{
                    id: lensVariantId,
                    quantity: 1
                  }];
                  
                  // Adicionar parent_line_key se disponível (cria a relação pai-filho)
                  if (parentLineKey) {
                    lensItems[0].parent_line_key = parentLineKey;
                    console.log('🔗 Criando relação pai-filho: lente -> armação');
                  }
                  
                  // Construir o body JSON
                  const lensBody = {
                    items: lensItems
                  };
                  
                  // Se tem cart, incluir as seções no request
                  if (this.cart) {
                    // Usar section.section se disponível, caso contrário usar section.id
                    lensBody.sections = this.cart.getSectionsToRender().map((section) => section.section || section.id);
                    lensBody.sections_url = window.location.pathname;
                  }
                  
                  lensConfig.body = JSON.stringify(lensBody);
                  
                  const lensResponse = await fetch(`${routes.cart_add_url}`, lensConfig);
                  const lensData = await lensResponse.json();
                  
                  if (lensData.status) {
                    console.warn('⚠️ Erro ao adicionar lente:', lensData.description);
                  } else {
                    if (parentLineKey) {
                      console.log('✅ Lente adicionada com sucesso como nested cart line (filha da armação)');
                    } else {
                      console.log('✅ Lente adicionada com sucesso (sem relação pai-filho - fallback)');
                    }
                    
                    // Se a lente foi adicionada com sucesso, mesclar os dados
                    if (this.cart && lensData.sections) {
                      // Mesclar as seções atualizadas da lente com o response original
                      // Priorizar as seções da lente pois são mais recentes
                      response = {
                        ...response, // Manter propriedades originais (items, item_count, etc)
                        sections: lensData.sections, // Usar seções atualizadas que incluem ambos os itens
                        key: lensData.key || response.key // Usar a key da lente (último item adicionado)
                      };
                    } else if (lensData.key) {
                      // Se não tem cart mas a lente foi adicionada, atualizar apenas a key
                      response.key = lensData.key;
                    }
                  }
                } catch (lensError) {
                  console.error('❌ Erro ao adicionar lente:', lensError);
                  // Continuar mesmo com erro na lente, o óculos já foi adicionado
                }
              }
            }

            if (!this.error) {
              // Passar informação se veio do popup de lentes
              const sourceInfo = isLensPopup && hasLensSelected 
                ? { source: 'product-form', isLensPopup: true, productVariantId: formData.get('id'), cartData: response }
                : { source: 'product-form', productVariantId: formData.get('id'), cartData: response };
              
              publish(PUB_SUB_EVENTS.cartUpdate, sourceInfo);
            }
            this.error = false;
            const is_cart_page = document.body.classList.contains('template-cart');
            if (!is_cart_page) {
              // Se adicionou lente, o response já tem as seções atualizadas
              // Se não adicionou lente, o response original já tem as seções
              if (this.cart && typeof this.cart.renderContents === 'function') {
                this.cart.renderContents(response);
              }
            }else{
              closePopup.hide();
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading-overlay__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
    }
  );
}
